import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import { SubscriptionUpdatePayload } from '@app/utils/interfaces/subscription-update-payload.interface';
import { SubscriptionResponse } from '@app/utils/interfaces/plans.interface';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  public defaultStipeMethod = signal<string>('');
  public activePlanId = signal<number | null>(null);

  private readonly baseUrl = environment.apiBaseUrl;
  private readonly httpClient = inject(HttpClient);

  public updateSubscription(newSubscriptionId: number): Observable<void> {
    const calculatedId = newSubscriptionId - 1;
    const payload: SubscriptionUpdatePayload = {
      newPlan: calculatedId,
      stripePaymentMethodId: this.defaultStipeMethod(),
    };

    return this.httpClient.put<void>(
      `${this.baseUrl}${ApiEndpoints.PUT_CHANGE_SUBSCRIPTION}`,
      payload,
    );
  }

  public getSubscribtionPlans(): Observable<SubscriptionResponse> {
    return this.httpClient.get<SubscriptionResponse>(
      `${this.baseUrl}${ApiEndpoints.GET_SUBSCRIPTION_PANS}`,
    );
  }
}
